<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			d="M13.3333 14.1668C13.3333 13.7248 13.1576 13.301 12.8451 12.9884C12.5325 12.6759 12.1087 12.5002 11.6667 12.5002H8.33333C7.89131 12.5002 7.46751 12.6759 7.15495 12.9884C6.84239 13.301 6.66667 13.7248 6.66667 14.1668V15.0002H13.3333V14.1668ZM11.6667 6.66683C11.6667 6.2248 11.4909 5.801 11.1784 5.48844C10.8658 5.17588 10.442 5.00016 10 5.00016C9.55797 5.00016 9.13417 5.17588 8.82161 5.48844C8.50905 5.801 8.33333 6.2248 8.33333 6.66683C8.33333 7.10886 8.50905 7.53265 8.82161 7.84521C9.13417 8.15777 9.55797 8.3335 10 8.3335C10.442 8.3335 10.8658 8.15777 11.1784 7.84521C11.4909 7.53265 11.6667 7.10886 11.6667 6.66683ZM15 15.0002C15 15.4422 14.8243 15.866 14.5117 16.1785C14.1992 16.4911 13.7754 16.6668 13.3333 16.6668H6.66667C6.22464 16.6668 5.80084 16.4911 5.48828 16.1785C5.17572 15.866 5 15.4422 5 15.0002V14.1668C5 13.2828 5.35144 12.4352 5.97656 11.8101C6.60168 11.1849 7.44928 10.8335 8.33333 10.8335H11.6667C12.5507 10.8335 13.3983 11.1849 14.0234 11.8101C14.6486 12.4352 15 13.2828 15 14.1668V15.0002ZM13.3333 6.66683C13.3333 7.55088 12.9819 8.39848 12.3568 9.0236C11.7316 9.64872 10.8841 10.0002 10 10.0002C9.11595 10.0002 8.26835 9.64872 7.64323 9.0236C7.01811 8.39848 6.66667 7.55088 6.66667 6.66683C6.66667 5.78277 7.01811 4.93518 7.64323 4.31006C8.26835 3.68494 9.11595 3.3335 10 3.3335C10.8841 3.3335 11.7316 3.68494 12.3568 4.31006C12.9819 4.93518 13.3333 5.78277 13.3333 6.66683Z"
			fill="currentColor"
		/>
	</svg>
</template>
